const ValueType = `
  id
  description
`;

export default ValueType;
